import ThoughtOfTheDay from "./ThoughtOfTheDay";
export default ThoughtOfTheDay;